/**
 * Generate Study Dialog - Step 3: Select Study
 *
 * Migrated from: lego/page/etmf/overview/generate-study/Step3.jsx
 */

import React from 'react'
import { FormikProps } from 'formik'
import { useDialogContext } from './context/useDialogContext'
import { useServiceContext } from '../../../../root'
import { Select } from '../../../../components/Select/Select'
import type { FormValues, SelectOption } from './context/DialogContext'
import type { OptionType } from '../../../../components/Select/Select'

interface Step3Props extends Partial<FormikProps<FormValues>> {}

export function Step3({ values, setFieldValue, errors }: Step3Props) {
  const dialogData = useDialogContext()
  const context = useServiceContext()
  const { translate } = context.service.filter

  // Transform SelectOption to OptionType format for the Select component
  const options: OptionType[] = dialogData.studyOptions.map((opt) => ({
    value: opt.value,
    label: opt.label
  }))

  return (
    <div className="step step3">
      <div className="form-group w50p">
        <div className="mcc-form-group">
          <label htmlFor="study-select" className="has-step-circle control-label mb10">
            <span className="step-circle">2</span>
            <span>{translate('ETMF_GENERATE_TRIAL_STRCT_TITLE_STEP4')}</span>
          </label>
        </div>
        <Select
          id="study-select"
          name="study"
          value={values?.study}
          options={options}
          placeholder={translate('SELECT_STUDY')}
          isClearable={false}
          isSearchable={true}
          onChange={(option) => {
            setFieldValue?.('study', option ? (option as OptionType).value : null)
          }}
        />
        {errors?.study && <div className="text-danger fs14">{errors.study}</div>}
      </div>
    </div>
  )
}

export default Step3
